import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "order-page" }
const _hoisted_2 = {
  key: 0,
  class: "order-page__loader"
}
const _hoisted_3 = {
  key: 1,
  class: "order-page__content"
}
const _hoisted_4 = { class: "container" }
const _hoisted_5 = { class: "order-page__section" }
const _hoisted_6 = { class: "heading heading--3 order-page__date order-page__section-title" }
const _hoisted_7 = { class: "order-page__section" }
const _hoisted_8 = { class: "heading heading--3 order-page__section-title" }
const _hoisted_9 = { class: "checkout-confirm-page__info-item" }
const _hoisted_10 = { class: "checkout-confirm-page__info-item-label" }
const _hoisted_11 = { class: "order-page__section" }
const _hoisted_12 = { class: "heading heading--3 order-page__section-title" }
const _hoisted_13 = { class: "checkout-confirm-page__info-item-label" }
const _hoisted_14 = { class: "checkout-confirm-page__info-item-value" }
const _hoisted_15 = { style: {"padding-right":"1em"} }
const _hoisted_16 = { class: "order-page__section" }
const _hoisted_17 = { class: "heading heading--3 order-page__section-title" }
const _hoisted_18 = { class: "checkout-confirm-page__info-item" }
const _hoisted_19 = { class: "checkout-confirm-page__info-item-label" }
const _hoisted_20 = {
  key: 0,
  class: "checkout-confirm-page__info-item-value"
}
const _hoisted_21 = { class: "order-page__section" }
const _hoisted_22 = { class: "heading heading--3 order-page__section-title" }
const _hoisted_23 = { class: "checkout-confirm-page__info-item" }
const _hoisted_24 = { class: "checkout-confirm-page__info-item-label" }
const _hoisted_25 = {
  key: 0,
  class: "order-page__section"
}
const _hoisted_26 = { class: "heading heading--3 order-page__section-title" }
const _hoisted_27 = { class: "checkout-confirm-page__info-item" }
const _hoisted_28 = { class: "checkout-confirm-page__info-item-label" }
const _hoisted_29 = { class: "iconed-text" }
const _hoisted_30 = { class: "order-page__section" }
const _hoisted_31 = { class: "heading heading--3 order-page__section-title" }
const _hoisted_32 = { class: "checkout-confirm-page__info-item" }
const _hoisted_33 = { class: "checkout-confirm-page__info-item-label" }
const _hoisted_34 = { class: "order-page__section" }

import AppHeader from '@/components/AppHeader.vue';
import AppBtn from '@/components/AppBtn.vue';
import { useRoute, useRouter } from 'vue-router';
import useOrdersStore from '@/store/orders';
import moment from 'moment';
import helpers from '@/helpers';
import AppLoader from '@/components/AppLoader.vue';
import { onMounted, ref } from 'vue';
// eslint-disable-next-line import/no-cycle
import { useTelegramWebApp } from '@/services/telegram-web-app';
import IconMapPin from '@/icons/icon-map-pin.vue';
import useShoppingCartStore from '@/store/shopping-cart';
import useProductsStore from '@/store/products';
import { Order, OrderProduct, ShippingCartProduct } from '@/types/app';
import { useI18n } from 'vue-i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'OrderPage',
  setup(__props) {

const shoppingCart = useShoppingCartStore();
const telegramWebApp = useTelegramWebApp();
const route = useRoute();
const router = useRouter();
const orderId = parseInt(route.params.orderId as string, 10);
const ordersStore = useOrdersStore();
const productsStore = useProductsStore();
const order = ref<Order>();
const i18n = useI18n();

if (!ordersStore.isOrdersLoaded && !ordersStore.isLoadingOrders) {
  ordersStore.loadOrders();
}

const isRepeatLoading = ref(false);
const shippingCost = ref<number|null>(null);
const repeatOrder = async () => {
  isRepeatLoading.value = true;
  await productsStore.loadProducts();
  const products: ShippingCartProduct[] = order.value!.products
    .filter((e: OrderProduct) => (productsStore
      .getProduct(e.productId)?.quantity ?? 0) >= e.quantity)
    .map((e) => ({
      product: productsStore.getProduct(e.productId)!,
      quantity: e.quantity,
    }));
  if (products.length !== order.value!.products.length) {
    isRepeatLoading.value = false;
    telegramWebApp.showAlert(i18n.t('errorQuantityRepeatOrder'));
    return;
  }
  await shoppingCart.clear();
  await shoppingCart.changeProductQuantity(products);
  router.push({ name: 'cart' });
};

const init = async () => {
  telegramWebApp.hideMainBtn();
  if (!ordersStore.isOrdersLoaded) {
    await ordersStore.loadOrders();
  }
  order.value = ordersStore.getOrder(orderId)!;
  shippingCost.value = order.value!.totals.find((e) => e.code === 'shipping')?.value ?? null;
};

onMounted(() => {
  init();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(AppHeader, {
      "with-search": false,
      title: `${_ctx.$t('order')} №${_unref(orderId)}`
    }, null, 8, ["title"]),
    (!order.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createVNode(AppLoader)
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(moment)(order.value.dateAdded).format('LLL')), 1)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.$t('status')), 1),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, _toDisplayString(order.value.orderStatus), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t('productsAndQuantity')), 1),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(order.value.products, (orderProduct) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: orderProduct.orderProductId,
                  class: "checkout-confirm-page__info-item"
                }, [
                  _createElementVNode("div", _hoisted_13, _toDisplayString(orderProduct.name), 1),
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("span", _hoisted_15, "x" + _toDisplayString(orderProduct.quantity), 1),
                    _createTextVNode(" " + _toDisplayString(_unref(helpers).formatCurrency(orderProduct.price)), 1)
                  ])
                ]))
              }), 128))
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t('shipping')), 1),
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, _toDisplayString(order.value.shippingMethod), 1),
                (shippingCost.value !== null)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(_unref(helpers).formatCurrency(shippingCost.value)), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.$t('total')), 1),
              _createElementVNode("div", _hoisted_23, [
                _createElementVNode("div", _hoisted_24, _toDisplayString(_unref(helpers).formatCurrency(order.value.total)), 1)
              ])
            ]),
            (order.value.shippingAddress)
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, _toDisplayString(_ctx.$t('shippingAddress')), 1),
                  _createElementVNode("div", _hoisted_27, [
                    _createElementVNode("div", _hoisted_28, [
                      _createElementVNode("div", _hoisted_29, [
                        _createVNode(IconMapPin),
                        _createTextVNode(" " + _toDisplayString(order.value.shippingAddress), 1)
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, _toDisplayString(_ctx.$t('payment')), 1),
              _createElementVNode("div", _hoisted_32, [
                _createElementVNode("div", _hoisted_33, _toDisplayString(order.value.paymentMethod), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_34, [
              _createVNode(AppBtn, {
                class: "order-page__repeat-btn",
                onClick: _withModifiers(repeatOrder, ["prevent"]),
                "is-loading": isRepeatLoading.value
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('repeatOrder')), 1)
                ]),
                _: 1
              }, 8, ["onClick", "is-loading"])
            ])
          ])
        ]))
  ]))
}
}

})